import { createFileRoute } from "@tanstack/react-router";
import { ChatPage } from "@/features/chat/ChatPage";
import { chatSearch } from "@/features/chat/route-params";

/** P72 Team chat (docs/frontend/PAGES.md). One channel, DM or client channel per URL. */
export const Route = createFileRoute("/_app/chat/$channel")({
  validateSearch: chatSearch,
  component: Page,
});

function Page() {
  const { channel } = Route.useParams();
  return <ChatPage channel={channel} search={Route.useSearch()} />;
}
